import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { convertCurrency } from '../../../common/helpers/currency-helper';
import { calculateWidth } from '../../../common/helpers/dimension-helper';
import { ITransactionListing } from '../../../common/helpers/transaction-helper';
import { ReactComponent as Transactions } from '../../../common/media/Transactions.svg';
import { themeColor } from '../../../mui-theme';
import VerticalCenter from '../../../vertical-center/vertical-center';
import { CheckMark } from './transaction-list-checkmark';
import { styles } from './transaction-list-styles';

export interface ITransactionListProps {
  transactions: ITransactionListing[];
  onTransactionClick: (transaction: ITransactionListing) => void;
  selectedTransactionID?: string;
}

const TransactionList = ({
  transactions,
  selectedTransactionID,
  onTransactionClick,
}: ITransactionListProps): JSX.Element => {
  const classes = styles();
  return (
    <Grid
      container
      alignContent='flex-start'
      className={classes.component}
      data-testid='transaction-list'
    >
      {transactions.map(transaction => {
        const transactionId = transaction.transactionId;
        return (
          <Grid item xs={12} key={transactionId}>
            <TransactionItem
              transaction={transaction}
              selected={selectedTransactionID === transaction.transactionId}
              onClick={() => onTransactionClick(transaction)}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default TransactionList;

interface ITransactionItemProps {
  transaction: ITransactionListing;
  selected: boolean;
  onClick: () => void;
}

const Item = ({ transaction, selected, onClick }: ITransactionItemProps): JSX.Element => {
  const classes = styles();
  const { touchPointId, sequenceNumber, suspendTime, totalOrderAmount } = transaction;
  const transactionTotal = convertCurrency(totalOrderAmount);

  return (
    <Grid
      container
      className={classes.transactionItemContainer}
      onClick={onClick}
      style={{
        borderColor: selected ? themeColor.primaryDark : themeColor.secondaryLight,
      }}
      data-testid='transaction-list-item'
    >
      {selected && (
        <div className={classes.transactionItemCheck} data-testid='transaction-list-item-check'>
          <CheckMark />
        </div>
      )}

      <Grid item xs={1}>
        <VerticalCenter
          justifyContent='flex-start'
          containerStyle={{ paddingLeft: calculateWidth(16).stringValue }}
        >
          <Transactions className={classes.transactionImage} />
        </VerticalCenter>
      </Grid>
      <Grid item xs={3}>
        <VerticalCenter justifyContent='flex-start' alignContent='center'>
          <Grid item xs={12}>
            <Typography className={classes.transactionSequenceNumber}>{sequenceNumber}</Typography>
          </Grid>
          <Grid item xs={12}>
            {' '}
            <Typography
              className={classes.transactionItemName}
              data-testid='transaction-item-tp-id'
            >
              {touchPointId}
            </Typography>
          </Grid>
        </VerticalCenter>
      </Grid>

      <Grid item xs={5}>
        <VerticalCenter justifyContent='flex-start'>
          <Typography className={classes.transactionDate}>{suspendTime}</Typography>
        </VerticalCenter>
      </Grid>
      <Grid item xs={3}>
        <VerticalCenter
          justifyContent='flex-end'
          containerStyle={{ paddingRight: calculateWidth(22.1).stringValue }}
        >
          <Typography className={classes.transactionTotal} data-testid='transaction-item-total'>
            {transactionTotal}
          </Typography>
        </VerticalCenter>
      </Grid>
    </Grid>
  );
};

export const TransactionItem = React.memo(Item);
